// Copyright 2016 Sorama B.V.

export class Complex {
    public Real: number;
    public Imaginary: number;

    constructor(real: number, imaginary: number) {
        this.Real = real;
        this.Imaginary = imaginary;
    }

    public Magnitude(): number {
        return Math.sqrt(this.Real * this.Real + this.Imaginary * this.Imaginary);
    }

    public static Add(a: Complex, b: Complex): Complex {
        return new Complex(a.Real + b.Real, a.Imaginary + b.Imaginary);
    }

    public static Offset(a: Complex, b: number): Complex {
        return new Complex(a.Real + b, a.Imaginary + b);
    }

    public static Scale(a: Complex, b: number): Complex {
        return new Complex(a.Real * b, a.Imaginary * b);
    }

    public static Substract(a: Complex, b: Complex): Complex {
        return new Complex(a.Real - b.Real, a.Imaginary - b.Imaginary);
    }

    public static Multiply(a: Complex, b: Complex): Complex {
        return new Complex(a.Real * b.Real - a.Imaginary * b.Imaginary, a.Real * b.Imaginary + a.Imaginary * b.Real);
    }

    public static Exp(amplitude: number, phase: number): Complex {
        return new Complex(amplitude * Math.cos(phase), amplitude * Math.sin(phase));
    }
}
